<template>
    <div class="user_rsv_table_wrap">
        <div v-if="isLoading" class="loading_bg round_none" style="z-index: 999;">
            <div class="loading_wrap">
                <div class="loading_obj">
                    <svg class="spinner" width="60px" height="60px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                        <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                    </svg>
                </div>
            </div>
        </div>
        <div class="table2_xyscroll sticky">
            <table class="table2_default pd_small">
                <colgroup>
                    <col width="135px">
                    <col width="100px">
                    <col width="100px">
                    <col width="135px">
                    <col width="300px">
                </colgroup>
                <thead>
                    <tr>
                        <th>{{ $t('popup_user_reservation.label_appointment_date_time') }}</th>
                        <th>{{ $t('popup_user_reservation.label_department_short') }}</th>
                        <th>{{ $t('popup_user_reservation.label_staff') }}</th>
                        <th>{{ $t('popup_user_reservation.label_program') }}</th>
                        <th>{{ $t('popup_user_reservation.label_appointment_memo_short') }}</th>
                    </tr>
                </thead>
                <tbody v-if="!isEmpty">
                    <ReservationHistoryTableItem v-for="reservation in reservations" :key="reservation._id" 
                        :reservation="reservation"
                        :selectedReservationID="selectedReservationID"
                        @setSelectedReservationID="handleSetSelectedReservationID"
                        @showReservationChangeHistory="handleShowReservationChangeHistory"
                        @hideReservationChangeHistory="handleHideReservationChangeHistory"
                    />
                </tbody>
                <tbody v-if="isEmpty">
                    <tr>
                        <td class="lgray_txt txt_center" colspan="5">{{ $t('common.label_no_content') }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>


<script>
import ReservationHistoryTableItem from './ReservationHistoryTableItem.vue'

export default {
    components: { ReservationHistoryTableItem },
    props: {
        reservations: Array,
        selectedReservationID: String,
        isLoading: Boolean
    },
    data() {
        return {
            results: []
        }
    },
    computed: {
        isEmpty: function() {
            return (this.reservations?.length ?? 0) == 0
        },
    },
    methods: {
        async loadReservation() {

        },

        handleSetSelectedReservationID(id) {
            this.$emit('setSelectedReservationID', id)
        },

        handleShowReservationChangeHistory() {
            this.$emit('showReservationChangeHistory')
        },

        handleHideReservationChangeHistory() {
            this.$emit('hideReservationChangeHistory')
        }
    }
}
</script>